import(/* webpackMode: "eager", webpackExports: ["handleError"] */ "/home/runner/work/porta-web/porta-web/apps/porta-nz/app/client-utils.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/apps/porta-nz/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next-sanity@11.6.10_@emotion+is-prop-valid@1.2.2_@sanity+client@7.22.1_@sanity+icons@3._98e0cea266058994b57ee6c1ab807f78/node_modules/next-sanity/dist/live/client-components/live-stream/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next-sanity@11.6.10_@emotion+is-prop-valid@1.2.2_@sanity+client@7.22.1_@sanity+icons@3._98e0cea266058994b57ee6c1ab807f78/node_modules/next-sanity/dist/live/client-components/live/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next-sanity@11.6.10_@emotion+is-prop-valid@1.2.2_@sanity+client@7.22.1_@sanity+icons@3._98e0cea266058994b57ee6c1ab807f78/node_modules/next-sanity/dist/visual-editing/client-component/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next-sanity@11.6.10_@emotion+is-prop-valid@1.2.2_@sanity+client@7.22.1_@sanity+icons@3._aeeaca47a05caf001f5d2a3bcac2efde/node_modules/next-sanity/dist/image/index.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next@16.2.9_@babel+core@7.29.7_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_c07bb2f7599f814f2a1edfd0e89eab37/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next@16.2.9_@babel+core@7.29.7_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_c07bb2f7599f814f2a1edfd0e89eab37/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next@16.2.9_@babel+core@7.29.7_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_c07bb2f7599f814f2a1edfd0e89eab37/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next@16.2.9_@babel+core@7.29.7_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_c07bb2f7599f814f2a1edfd0e89eab37/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next@16.2.9_@babel+core@7.29.7_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_c07bb2f7599f814f2a1edfd0e89eab37/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"variable\":\"--font-sora\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"600\",\"700\"]}],\"variableName\":\"sora\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/next@16.2.9_@babel+core@7.29.7_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_c07bb2f7599f814f2a1edfd0e89eab37/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Open_Sans\",\"arguments\":[{\"variable\":\"--font-openSans\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"600\",\"700\"]}],\"variableName\":\"openSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/porta-web/porta-web/node_modules/.pnpm/sonner@1.7.4_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/assets/images/gray.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/assets/images/greg-chatbot.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/assets/images/icon-chatbot.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/AskGreg/AskGreqSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ContactFormBlock/ContactFormBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ContactSupport/ContactSupport.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ContactSupport/ContactSupportSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ContactSupport/ContactSupportWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ContentCarousel/ContentCarouselBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ContentCarousel/useContentCarousel.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/DocumentsBlock/DocumentBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/DocumentsBlock/useDocumentBlock.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/FeatureSummary/FeatureSummary.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/Gallery/Gallery.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/Gallery/ui/GalleryView.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/Gallery/useGallery.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/HeroBannerCarousel/HeroBannerCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/HeroBannerCarousel/ui/HeroBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/HeroBannerCarousel/ui/HeroBannerSlide.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/HeroBannerCarousel/ui/HeroBannerVideo.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/HeroBannerCarousel/useHeroBannerSlide.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ImagesGrid/ImagesGrid.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/LogoWall/LogoWall.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/MasterTextBlock/MasterTextBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/MiddleBanner/MiddleBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/MilestoneRenderer/ui/MilestoneWithScroll.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/MultiColumnBanner/MultiColumnBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/Newsletter/Newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/Newsletter/useNewsletter.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/PageApplications/PageApplications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/blocks/PageBuilder.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductCarousel/ProductCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductCarousel/useProductCarousel.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductSlideshow/ProductSlideshow.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductSlideshow/useProductSlideshow.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductSummary/ProductSummary.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductType/ProductType.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductVariant/ProductVariant.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductVariant/ui/VariantCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductVariant/ui/Variants.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/ProductVariant/useVariants.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/TextIconList/TextIconList.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/TextSection/TextSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/VideoImageRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/blocks/VideoSlideCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useMediaQuery"] */ "/home/runner/work/porta-web/porta-web/packages/hooks/commons/useMediaQuery.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Accordion/useAccordion.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Buttons/Button.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Buttons/ButtonIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Buttons/TextButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Checkbox/CheckBox.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Dropdowns/Dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Dropdowns/DropdownButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Dropdowns/SelectDropdown.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Filter/Filter.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Filter/FilterMultiSelect.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Filter/useDropdownFilter.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Icon/Icon.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Image/AppImage.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Input/FileInput.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Input/Input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareIcons"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Links/ShareIcons.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/LinkWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Modal/Modal.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Pagination/PageInput.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Pagination/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/PopupInfo/PopupInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/Toast/DraftModeToast.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/AppVideoImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoCard"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/ui/InfoCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayButton"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/ui/PlayButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Thumbnail"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/ui/Thumbnail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/ui/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageVideoWithText"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/variants/ImageVideoWithText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoWithoutText"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/variants/VideoWithoutText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoWithText"] */ "/home/runner/work/porta-web/porta-web/packages/ui/common/VideoImage/variants/VideoWithText.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/AlgoliaShowMore.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/ClearRefinements/AlgoliaClearRefinements.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/ClearRefinements/ClearRefinements.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/CurrentRefinements.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/GeoRadiusContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/Hit/SearchPageHit.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/LoadingIndicator.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/MenuSelect.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/NoResultsBoundary/EmptyQueryBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/NoResultsBoundary/NoResultsBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/Pagination/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/SearchBox/PlacesSearchBox.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/SearchBox/SearchBox.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/SearchFilterRadio.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/TagRefinements.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/AlgoliaSearch/ToggleRefinement/ToggleRefinement.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/CaseStudy/CaseStudiesHit.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/CaseStudy/CaseStudyCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/CaseStudy/CaseStudyGrid.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ChatWidget/ChatContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatWidget"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/ChatWidget/ChatWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/ClientBoot/ClientBoot.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ContactForm/lib/useContactForm.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ContactForm/lib/useHubSpotFormFields.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ContactForm/ui/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ContactForm/ui/ContactFormFields.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/DocumentHub/DocumentHub.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/DocumentHub/DocumentHubItem.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/DocumentHub/DocumentHubLayout.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/DocumentHub/DocumentHubLoadMoreControls.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/DocumentHub/hooks/useAccordionState.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/DocumentHub/hooks/useDocumentHubData.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/DocumentHub/hooks/useTagDiscovery.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/FAQ/ui/FAQList.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Footer/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Footer/lib/useFooter.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/GTM/GTMInline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/GTM/GTMPageView.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/hooks/useHeader.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/hooks/useHeaderModel.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/hooks/useNavigationGroup.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/ui/HeaderSearch/HeaderSearch.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/ui/Logo.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/ui/MobileNavigation.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/ui/NavigationBar.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/ui/NavigationGroup.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/ui/NavigationItem.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Header/ui/PrimaryButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/MegaMenu/Grid/GridMegaMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/MegaMenu/List/ListMegaMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MegaMenuContainer"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/MegaMenu/MegaMenuContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMegaMenu"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/MegaMenu/Mobile/MobileMegaMenu.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ProductDetail/ProductDetailLevel3.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ProductDetail/ProductImageCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ProductDetail/ProductVariantSelector.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ProductDetail/useProductDetailCarousel.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/ProductDetail/useProductDetailTemplate.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Products/ProductItem.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Products/ProductItemHit.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/Products/ProductList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/porta-web/porta-web/packages/widgets/StoreLocator/ListStoreInstantSearch.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/porta-web/porta-web/packages/widgets/StoreLocator/StoreCard.tsx");
